import { DAY_IN_MS } from './time';
import type { MarketplaceReviewPromptState } from 'src/types/marketplaceReview';

export const MARKETPLACE_REVIEW_PROMPT_STORAGE_KEY =
  'MARKETPLACE_REVIEW_PROMPT_STATE';

export const MARKETPLACE_REVIEW_SHOW_PROBABILITY = 0.1;

export const MARKETPLACE_REVIEW_PROMPT_COOLDOWN_DAYS = 30;
export const MARKETPLACE_REVIEW_PROMPT_COOLDOWN_MS =
  MARKETPLACE_REVIEW_PROMPT_COOLDOWN_DAYS * DAY_IN_MS;

export const MARKETPLACE_REVIEW_PROMPT_DEFAULT_STATE: MarketplaceReviewPromptState =
  {
    lastPromptedAt: null,
    dismissedPermanently: false,
  };

export const MARKETPLACE_REVIEW_PROMPT_TITLE_KEY =
  'marketplace_review_prompt_title';
export const MARKETPLACE_REVIEW_PROMPT_BODY_KEY =
  'marketplace_review_prompt_body';
export const MARKETPLACE_REVIEW_PROMPT_PRIMARY_ACTION_KEY =
  'marketplace_review_prompt_primary_action';
export const MARKETPLACE_REVIEW_PROMPT_SECONDARY_ACTION_KEY =
  'marketplace_review_prompt_secondary_action';
